export interface Novel {
  id: string;
  title: string;
  author: string;
  description: string;
  coverColor: string; // Tailwind gradient/color class
  content: string;
  scraped?: boolean;
  publisher?: string;
  ncode?: string;
  url?: string;
  downloadedAt?: string;
  lastUpdatedAt?: string;
  episodesCount?: number;
  type?: 'series' | 'short';
  genre?: string;
  tags?: string[];
  status?: 'ongoing' | 'completed' | 'short';
  charCount?: number;
}

export const SAMPLE_NOVELS: Novel[] = [
  {
    id: 'merose',
    title: '走れメロス',
    author: '太宰 治',
    description:
      'メロスは激怒した。必ず、かの邪智暴虐の王を除かなければならぬと決意した。友情と信頼を貫くため、メロスは走る。',
    coverColor: 'from-amber-600 to-red-700',
    charCount: 1330,
    content: `# 走れメロス
太宰 治

<!-- ======================================== --> <!-- 1_日常と決意 --> <!-- ======================================== -->
メロスは|激怒《げきど》した。必ず、かの|邪智暴虐《じゃちぼうぎゃく》の|王《おう》を|除《のぞ》かねばならぬと決意した。メロスには政治がわからぬ。メロスは、村の|牧人《ぼくじん》である。笛を吹き、羊と遊んで暮して来た。けれども邪悪に対しては、人一倍に敏感であった。

きょう未明メロスは村を出発し、野を越え山越え、十里はなれた此のシラクスの市にやって来た。メロスには無二の友がある。セリヌンティウスである。今は此のシラクスの市で、|石工《いしく》をしている。その友を、これから訪ねるのである。

<!-- ======================================== --> <!-- 2_暴君の疑惑 --> <!-- ======================================== -->
街を歩いて、メロスは妙に不審に思った。寂しいのだ。
「何かあったのか」と通行人に尋ねた。
「王様が、人を殺すのです」
「なぜ殺すのだ」
「悪心を抱いている、というので。最初は、妹婿様を。それから、御自身のお世継ぎを。それから、皇后様を。それから、賢臣のあれこれを」
「呆れた王だ。生かして置けぬ」
メロスは、単純な男であった。買い物を背負ったまま、ずかずか城に入って行った。

たちまちメロスは捕縛された。
「この短刀で何をするつもりであったか、言え！」
暴君ディオニスは静かに、けれども威厳を以て問い詰めた。その王の顔は蒼白で、眉間の皺は、刻み込まれたように深かった。
「市を暴君の手から救うのだ」とメロスは悪びれずに答えた。

<!-- ======================================== --> <!-- 3_友を人質に --> <!-- ======================================== -->
「お前がか」王は憐れむように呟いた。「口の烈しい奴だ。お前には私の孤独の深さがわからぬ」
「人の心を疑うのは、最も恥ずべき悪徳だ。王は、民の忠誠をさえ疑って居られる」
「疑うのが、正当の心構えなのだと、お前たちに教えてくれたのだ。人の心は、あてにならない。私は死刑を恐れない。だが、私を信じる友を裏切ることはできない。私に三日間の日限を与えてくれ。たった一人の妹に、亭主を持たせてやりたい。私は必ず、三日目の日没までに帰ってくる」

「人質を置いていけ。戻らねば、その人質を殺す」
「では、私の無二の友、セリヌンティウスを人質にします」
王は驚き、そしてニヤリと笑った。どうせ戻ってこないだろう、その時に友を殺して、人の信実の虚しさを天下に見せつけてやるのだ、と考えたからである。

<!-- ======================================== --> <!-- 4_メロスの激走 --> <!-- ======================================== -->
メロスは走った。初日は一睡もせず、二日目の午前中に村に着き、妹の結婚式を無事に執り行った。三日目の早朝、メロスは再びシラクスに向けて走り出した。

しかし、天候が崩れ、大雨によって川が氾濫していた。橋は濁流に流され、渡ることは困難を極めた。
「ああ、神々よ。私をここで足止めするのか。私は約束を守らねばならぬ！」
メロスは激流に飛び込み、必死の思いで対岸に泳ぎ着いた。だが、困難はそれだけではなかった。山賊の襲撃、照りつける太陽による極度の疲労と渇き。
「もう、動けない。セリヌンティウス、許してくれ。私は走るのをやめるわけではないが、体力が尽きたのだ……」
メロスは草むらに倒れ込み、絶望しかけた。

<!-- ======================================== --> <!-- 5_信頼の勝利 --> <!-- ======================================== -->
その時、耳に清水の流れる音が聞こえた。湧き水を見つけ、一口飲むと、メロスの体に再び力がみなぎった。
「私は信じられている。友は私を信じて待っている。走るのだ、メロス！」
メロスは死力を尽くして走った。日没は刻一刻と迫る。シラクスの刑場では、セリヌンティウスが磔台に上げられようとしていた。

「待て！ その人を殺してはならぬ。メロスが帰ってきた。約束通り、今帰ってきた！」
メロスは群衆をかき分け、セリヌンティウスの足元に倒れ込んだ。
「セリヌンティウス、私を殴れ。私は一度だけ、途中で諦めようとした。君を裏切ろうとした」
セリヌンティウスはメロスを力いっぱい殴り、そして微笑んだ。
「メロス、今度は君が私を殴れ。私も一度だけ、君が帰ってこないのではないかと疑った」
二人はしっかりと抱き合い、涙を流した。

これを見た暴君ディオニスは、静かに近づき、言った。
「お前たちの勝ちだ。人の心には信実があるのだ。どうか私をも、お前たちの仲間に入れてくれないか」
刑場には、大きな歓声が沸き起こった。`,
  },
  {
    id: 'yodaka',
    title: 'よだかの星',
    author: '宮沢 賢治',
    description:
      'よだかは、実に見にくい鳥です。他の鳥から嫌われ、鷹からも名前を変えろと脅されます。悲しみに暮れたよだかは、星になることを決意します。',
    coverColor: 'from-slate-700 to-indigo-950',
    charCount: 1180,
    content: `# よだかの星
宮沢 賢治

<!-- ======================================== --> <!-- 1_よだかの悲哀 --> <!-- ======================================== -->
よだかは、実に見にくい鳥です。
顔は、味噌をつけたようにつぶれ、くちばしは平たくて、耳まで裂けています。足はよぼよぼで、一町とも歩けません。
ほかの鳥は、よだかの顔を見ただけでも、嫌になって顔を背けました。

それなのに、よだかの羽は実に立派で、灰色に美しい模様があり、風を切って飛ぶ様子は鷹のようでした。
しかし、名前が「よだか」であるため、本物の「タカ」からひどく嫌われていました。
「おい、お前。なぜその汚い顔で、俺の『タカ』という高貴な名前を名乗るのだ。今すぐ名前を改めろ。さもなければ、つかみ殺してしまうぞ」

<!-- ======================================== --> <!-- 2_理不尽な要求 --> <!-- ======================================== -->
鷹は、よだかに厳しい要求を突きつけました。
「明日までに、首に『市蔵』という名札をぶら下げて、他の鳥たちの家を回り、挨拶をしてこい。やらなければ、お前を引き裂いて殺す」
よだかは悲しくて悲しくて、自分の巣に戻り、じっとうずくまっていました。

「なぜ私はこんなに嫌われるのだろう。確かに私は醜い。しかし、何も悪いことはしていないはずだ。それなのに、なぜみんな私をいじめるのだろう」
よだかは夜になると飛び立ち、羽虫を口いっぱいに吸い込んで食べました。しかし、ふと気づいたのです。
「私は虫を食べて生きている。毎日毎日、たくさんの虫の命を奪っている。そして今度は、私が鷹に殺されようとしている。ああ、この世界の生き物は、みな傷つけ合って生きているのだ」

<!-- ======================================== --> <!-- 3_星への旅立ち --> <!-- ======================================== -->
よだかは決意しました。
「もう誰も傷つけたくない。私は遠くへ行こう。空の星になって、夜を照らすのだ」
よだかはまず、太陽にお願いに行きました。
「お天道様、どうか私をあなたのところに連れていってください。焼かれて死んでも構いません」
太陽は言いました。
「お前は昼の鳥ではない。星に頼んでみるが良い」

よだかは、夜空に輝くオリオンの星、大犬の星、大熊の星へと、必死に飛びながらお願いして回りました。
「どうか私をあなたのそばにおいてください」
しかし、どの星も「身分が違う」「冷たすぎる」と、よだかを相手にしませんでした。

<!-- ======================================== --> <!-- 4_よだかの星 --> <!-- ======================================== -->
よだかはもう羽がボロボロになり、力尽きて落ちていきました。
しかし、その時、彼の体はすうっと青く澄んだ光を放ち始めました。
よだかは、自分がどこを飛んでいるのかもわからなくなりましたが、ただ真っ直ぐに空へ昇っていきました。

そして、よだかはついに美しい青い星になりました。
今でも、夜空のオリオンの近くで、よだかの星は静かに青く燃え続けています。
他のどんな星よりも、静かに、そして美しく。`,
  },
];
